import { Pipe, PipeTransform } from '@angular/core';
import { ColumnText } from '@ddt-web/data-service';

@Pipe({ name: 'splitWordsAndRemoveLast' })
export class SplitWordsAndRemoveLastPipe implements PipeTransform {
	public transform(value: ColumnText): string[] {
		const words: string[] = [...value.toString().split(' ')];
		words.splice(words.length - 1);
		return words;
	}
}
